import { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Box, Typography, Checkbox, FormControlLabel } from "@mui/material";
import styles from './edit-card.module.scss';
import EditInfo from './edit-info';
import { categoriesWithDefaultAction, categoriesWithShowCard, defaultableCategories, defaultableLabels } from '../../constants/general';
import { useParams } from 'react-router';


const EditSection = observer(({ section, infos, labels, uiStore, category, defaultSection }) => {
    const [selected] = useState(labels.filter(i => uiStore.selectedInformation.includes(i._id)).map(i => i._id));
    const [defaults, setDefaults] = useState((['Socials', 'Name'].includes(category) ? uiStore.defaults[section.name] : uiStore.defaults[category])
        ||
        { sectionID: null, infoIDs: [] });

    const { cardId } = useParams();
    const [labelsWithInfo, setLabelsWithInfo] = useState([]);
    const [filteredSelected, setFilteredSelected] = useState([]);

    useEffect(() => {
        const filteredLabels = labels?.filter(i => i.section === section._id);
        const temp = []
        filteredLabels.forEach(element => {
            const info = infos?.find(i => i.label === element._id);
            if (info)
                temp.push({ ...element, info });
        });

        setLabelsWithInfo(temp)
        setFilteredSelected(selected.filter(i => temp.find(k => k._id === i)));
        setDefaults((['Socials', 'Name'].includes(category) ? uiStore.defaults[section.name] : uiStore.defaults[category])
            ||
            { sectionID: null, infoIDs: [] })

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [infos, labels, section._id])

    const selectInfo = (id) => {
        if (filteredSelected.includes(id)) {
            setFilteredSelected(filteredSelected.filter(i => i !== id))
            uiStore.unselectInfo([id], cardId);
        } else {
            setFilteredSelected([...filteredSelected, id]);
            uiStore.selectInfo([...filteredSelected, id], cardId);
        }
    };

    const toggleSelectAll = () => {
        if (filteredSelected.length === 0) {
            setFilteredSelected(labelsWithInfo.map(i => i._id))
            uiStore.selectInfo(labelsWithInfo.map(i => i._id), cardId);
        } else {
            setFilteredSelected([])
            uiStore.unselectInfo(filteredSelected, cardId);
        }
    }

    const toggleDefault = async (info) => {
        if (!defaultSection) {
            await uiStore.updateDefaultSection(section._id, ['Socials', 'Name'].includes(category) ? section.name : category);
        }

        const found = defaults.infoIDs.find(i => i._id === info._id)
        if (found) {
            //undefault
            const newDefaults = { ...defaults }
            newDefaults.infoIDs = newDefaults.infoIDs.filter(i => i._id !== info._id);
            setDefaults(newDefaults);
            await uiStore.toggleDefault(info._id, info.label, info.category, cardId, section.name);
        } else {
            //default
            const newDefaults = { ...defaults }
            newDefaults.infoIDs = [...newDefaults.infoIDs, info];
            setDefaults(newDefaults);
            await uiStore.toggleDefault(info._id, info.label, info.category, cardId, section.name);
        }
    }

    return (
        <Box key={section._id} className={styles.sectionBox} sx={{ mb: 4, mt: 4 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <FormControlLabel control={<Checkbox onChange={toggleSelectAll} checked={filteredSelected.length >= labelsWithInfo.length} />} label="Select All" fontSize={12} />
                <Typography fontSize={12} sx={{ mt: 1 }}>
                    {categoriesWithShowCard.includes(category) && 'Show On Card'}
                    {categoriesWithDefaultAction.includes(category) && 'Set Default'}
                </Typography>
            </Box>

            {labelsWithInfo.map((item) =>
                <EditInfo
                    key={item._id}
                    label={item}
                    uiStore={uiStore}
                    defaultable={defaultableLabels.includes(item.name) && defaultableCategories.includes(category)}
                    selected={filteredSelected.includes(item._id)}
                    selectInfo={selectInfo}
                    defaultSection={defaultSection}
                    initDefault={defaults?.infoIDs.find(i => i.label === item._id)}
                    toggleDefault={toggleDefault}
                />
            )}
        </Box>
    );

});

export default EditSection;